import { ColDef } from "ag-grid-community";
import { RowDef } from "../../components/ag-grid-extensions/models/RowDef";
import i18n from "../../services/localization-service/i18n";
import { IUserPermission } from "../../services/user-role-administration-service/Models";
import { TimeframeTypeEnum } from "../../common/enums/TimeframeTypeEnum";
import { getTimeframeTimeDisplayText } from "../../common/utilities/TimeframeUtilities";
import { Theme } from "@mui/material";


const projectRow = (
    entry: IUserPermission): RowDef => {

    let row: RowDef = {
    };

    row['firstName'] =  entry.firstName;
    row['lastName'] = entry.lastName;
    row['userID'] = entry.userID;
    row['accountActive'] = entry.accountActive;
    row['lastLoginTime'] = entry.lastLoginTime ? getTimeframeTimeDisplayText(TimeframeTypeEnum.None, entry.lastLoginTime) : '';
    row['roleList'] = entry.roleList;
    row['group'] = entry.group;
    row['permissionType'] = entry.permissionType;
    row['read'] = entry.read;
    row['write'] = entry.write;
    row['execute'] = entry.execute;
    row['manualEdit'] = entry.manualEdit;
    row['liveData'] = entry.liveData;
    row['control'] = entry.control;
    row['disable'] = entry.disable;


    return row;
}

const UserPermissionsReportUtils = {

    createGridRows: function (entries: IUserPermission[] | undefined): RowDef[] {

        const rows: RowDef[] = entries?.map((o) => {

            return projectRow(o);

        }) ?? [];


        return rows;
    },
    createGridColumns: function (theme: Theme): ColDef[] {

        let cols: ColDef[] = [{
            headerName: i18n.t("permissionReport.firstName") as string,
            field: 'firstName',
            type: "text"
            //sortable: true,
            //flex: 1,
            //minWidth: 200
        }, {
            headerName: i18n.t("permissionReport.lastName") as string,
            field: 'lastName',
            type: "text"
            //sortable: true,
            //flex: 1,
            //minWidth: 200
        }, {
            headerName: i18n.t("permissionReport.userID") as string,
            field: 'userID',
            type: "text",
            //sortable: true,
            //flex: 1,
            //minWidth: 240
        }, {
            headerName: i18n.t("permissionReport.accountActive") as string,
            field: 'accountActive',
            maxWidth: 148,
            type: "text"
            //sortable: true,
            ////flex: 1
            //width: 160
        }, {
            headerName: i18n.t("permissionReport.lastLoginTime") as string,
            field: 'lastLoginTime',
            type: "text, multiline"
            //comparator: timestampComparator
            //sortable: true,
            //flex: 1,
            //minWidth: 200
        }, {
            headerName: i18n.t("permissionReport.roleList") as string,
            field: 'roleList',
            type: "text, multiline"
        }, {
            headerName: i18n.t("permissionReport.group") as string,
            field: 'group',
            maxWidth: 148,
            type: "text, multiline"
        }, {
            headerName: i18n.t("permissionReport.permissionType") as string,
            field: 'permissionType',
            type: "text, multiline"
        }, {
            headerName: i18n.t("permissionReport.read") as string,
            field: 'read',
            maxWidth: 128,
            type: "text"
        }, {
            headerName: i18n.t("permissionReport.write") as string,
            field: 'write',
            maxWidth: 138,
            type: "text"
        }, {
            headerName: i18n.t("permissionReport.execute") as string,
            field: 'execute',
            maxWidth: 148,
            type: "text"
        }, {
            headerName: i18n.t("permissionReport.manualEdit") as string,
            field: 'manualEdit',
            maxWidth: 148,
            type: "text"
        }, {
            headerName: i18n.t("permissionReport.liveData") as string,
            field: 'liveData',
            maxWidth: 148,
            type: "text"
        }, {
            headerName: i18n.t("permissionReport.control") as string,
            field: 'control',
            maxWidth: 148,
            type: "text"
        }, {
            headerName: i18n.t("permissionReport.disable") as string,
            field: 'disable',
            maxWidth: 148,
            type: "text"
        }];

        return cols;
    },
};

export default UserPermissionsReportUtils;
